export class UpdateAccountCompanyContactsRequest {
    'companyContacts';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "companyContacts",
            "baseName": "companyContacts",
            "type": "Array<CompanyContact>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateAccountCompanyContactsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
